import React from "react";

import { AlignVAT } from "@vp/ep-pricing";
import { PriceQuery } from "../../store/productPriceDetails.types";
import { PricePresentationType } from "../../types/prices";
import { DisplayVariant, PriceDisplayType, SelectionsWithQuantity } from "../../types/pricing/price-display.types";
import { PricingInfo } from "../../types/tieredPrices";
import CSRWrapper from "../CSRWrapper";
import PriceDisplayTransitionWrapper from "./PriceDisplayTransitionWrapper";

// 1. Accept details like mpvId, requestor, displayStrategy, selections (optionally), quantity (optionally) or quantityEnum (optionally),
// 2. Pass the details to PriceExtractionWrapper via PriceDisplayTransitionWrapper

export interface PriceDisplayProps extends PriceQuery {
  priceDisplayStrategy?: PricePresentationType;
  isQuantitySliderEnabled?: boolean;
  defaultPricingInfo?: PricingInfo;
  hideSetupFee?: boolean;
  hidePerUnitPrice?: boolean;
  hideVolumeDiscount?: boolean;
  hideMinimumOrderableQuantity?: boolean;
  alwaysShowMOQInfo?: boolean; //The prop will enable to show "No minimum quantity" when MOQ=1 if true
  /** Override locale for integrations where Ubik context is not available */
  locale?: string;
  /** Override tenant for integrations where Ubik context is not available */
  tenant?: string;
  hidePriceDetails?: boolean; // The prop will enable to hide price details like setup fee, per unit price, volume discount etc. and show only the final price.

  //props introduced for PriceDisplayV2, to avoid breaking changes for existing implementations of PriceDisplay
  productId?: string; // Alias for productKey, as PriceDisplayV2 uses productId naming
  requestedPriceDisplayStrategy?: PriceDisplayType; // Alias for priceDisplayStrategy, as PriceDisplayV2 uses requestedPriceDisplayStrategy naming
  developmentMode?: boolean;
  alignVAT?: AlignVAT;
  isTile?: boolean;
  alternateSelections?: SelectionsWithQuantity;
  displayVariant?: DisplayVariant; //enum for pricing displays. If passed as from, it will showcase price in the form of "From xx"
  /**
   * URL of the document reference for logo processing charge determination.
   * Takes precedence over `assumeDocRequiresCertification` when both are provided.
   */
  docRefUrl?: string;
  /**
   * Fallback boolean used when `docRefUrl` is unavailable.
   * When `true`, signals the document likely requires certification.
   */
  assumeDocRequiresCertification?: boolean;
  /**
   * When `true`, renders only the Logo Processing Charge or nothing.
   * Prevents fallthrough to normal pricing when neither docRefUrl nor
   * assumeDocRequiresCertification is set.
   */
  showLogoChargeOnly?: boolean;
}

const PriceDisplay = (props: PriceDisplayProps) => {
  return (
    // CSRWrapper added to avoid hydration error glitches for SSR rendered pages
    <CSRWrapper>
      <PriceDisplayTransitionWrapper {...props} />
    </CSRWrapper>
  );
};

export default PriceDisplay;
